const unionRegex = /[Uu][Nn][Ii][Oo][Nn]/;
const unionReplace = "Unio--n";
const isNotRegex = /[Ii][Ss][ ][Nn][Oo][Tt]/;
const isNotReplace = "is no--t";
const hashRegex = /[#]/;
const hashReplace = "HA----SH";
const txRegex = /[T][X]/;
const txReplace = "TEX--AS";
const whenRegex = /[Ww][Hh][Ee][Nn]/;
const whenReplace = "Wh--en";
const havingRegex = /[Hh][Aa][Vv][Ii][Nn][Gg]/;
const havingReplace = "Hav--ing";

const regexReplaces = [
  { regex: unionRegex, replace: unionReplace },
  { regex: isNotRegex, replace: isNotReplace },
  { regex: hashRegex, replace: hashReplace },
  { regex: txRegex, replace: txReplace },
  { regex: whenRegex, replace: whenReplace },
  { regex: havingRegex, replace: havingReplace },
];

export const replaceTriggers = (theString) => {
  regexReplaces.forEach(
    (obj) =>
      (theString = theString.replaceAll(
        new RegExp(obj.regex, "g"),
        obj.replace
      ))
  );
  return theString;
};
